<template>
    <div class="or-admin-news-card">
        <or-admin-news-card-title :title="options.title.value.slice(0,40)" @remove="$emit('remove')" @up="$emit('up')" @down="$emit('down')"/>
        <or-admin-textarea class="item nesting-main" :options="options.title" @unsaved="$emit('unsaved')"/>
        <or-admin-textarea class="item nesting-main" :options="options.text" @unsaved="$emit('unsaved')"/>
        <or-admin-textarea class="item nesting-main" :options="options.date" @unsaved="$emit('unsaved')"/>
    </div>
</template>

<script>
import orAdminNewsCardTitle from "./or-admin-news-card-title.vue"
import orAdminTextarea from "./or-admin-textarea.vue"
export default {
    components: {
        orAdminNewsCardTitle,
        orAdminTextarea
    },
    props: {
        options: Object,
    }
}
</script>

<style scoped>
    .item {
        margin-top: 20px;
    }
</style>